module.exports = __webpack_public_path__ + "img/pay-success.7fb7336f.png";